module.exports = __webpack_public_path__ + "poppins-v5-devanagari_latin-ext_latin-500.70e9051c6ebce0ffe149.svg";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-500.svg
// module id = ../../../../../src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-500.svg
// module chunks = styles